import { render } from "./SelectionFilter.vue?vue&type=template&id=4805978e&scoped=true"
import script from "./SelectionFilter.vue?vue&type=script&lang=js"
export * from "./SelectionFilter.vue?vue&type=script&lang=js"

import "./SelectionFilter.vue?vue&type=style&index=0&id=4805978e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4805978e"]])

export default __exports__